export default "__VITE_ASSET__b3DdOORs__"